import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRepeat } from '@fortawesome/sharp-regular-svg-icons/faRepeat';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexColumn } from 'ui-components/components/flex/column';

import { messages } from './messages';
import styles from './retry.module.less';

/**
 * Retry button component for surcharge API calls
 * @param {object} props
 * @param {() => void} props.triggerRetry - Function to trigger a retry
 * @param {boolean} props.isLoading - Whether the request is currently loading
 * @returns {React.ReactElement}
 */
export const RetrySection = ({ triggerRetry, isLoading }) => {
  return (
    <FlexColumn className={styles.container}>
      <FormattedMessage {...messages.pleaseRetry} />
      <Button className={styles.button} disabled={isLoading} onClick={triggerRetry} theme='tertiary'>
        <FontAwesomeIcon icon={faRepeat} />
        <FormattedMessage {...messages.retry} />
      </Button>
    </FlexColumn>
  );
};
